import React, { Component } from 'react';

export default class CustomerChat extends Component {
  componentDidMount(): void {
    const element = document.getElementById('hubspot-messages-iframe-container');
    if (!element && document.getElementById('hs-script-loader')) {
      const script = document.createElement('script');
      script.src = '//js.hs-scripts.com/5921081.js';
      script.async = true;
      script.id = 'hs-script-loader';
      document.body.appendChild(script);
    } else {
      element.style.setProperty('display', 'block', 'important');
      element.style.setProperty('width', '276px');
      element.style.setProperty('height', '258px');
    }
  }

  componentWillUnmount(): void {
    const element = document.getElementById('hubspot-messages-iframe-container');
    if (element) {
      element.style.setProperty('display', 'none', 'important');
    }
  }

  render(): JSX.Element {
    return <div id="hs-script-loader" />;
  }
}
